
import { defineComponent, onMounted, reactive, computed } from 'vue'

// icons
import clockSVG from '@/assets/icons/clock.svg'

export default defineComponent({
    props: {
        delayedTime: {
            type: String,
            default: null,
        },
    },
    components: { 'clock-svg': clockSVG },
    setup(props) {
        const state = reactive({
            hours: 0,
            minutes: 0,
            seconds: 0,
            isNegative: false,
            leftTime: '00:00:00',
        })

        const parseTime = (timeStr: string) => {
            const negative = timeStr.startsWith('-')
            const clean = timeStr.replace('-', '')
            const [h, m, s] = clean.split(':').map(Number)
            return { negative, h, m, s }
        }

        const formatTime = (h: number, m: number, s: number, negative: boolean) => {
            const hh = String(Math.abs(h)).padStart(2, '0')
            const mm = String(Math.abs(m)).padStart(2, '0')
            const ss = String(Math.abs(s)).padStart(2, '0')
            return `${negative ? '-' : ''}${hh}:${mm}:${ss}`
        }

        const tick = () => {
            let totalSeconds = state.hours * 3600 + state.minutes * 60 + state.seconds
            if (state.isNegative) totalSeconds -= 1
            else totalSeconds += 1

            if (totalSeconds < 0) {
                state.isNegative = true
                totalSeconds = Math.abs(totalSeconds)
            }

            const h = Math.floor(totalSeconds / 3600)
            const m = Math.floor((totalSeconds % 3600) / 60)
            const s = totalSeconds % 60

            state.hours = h
            state.minutes = m
            state.seconds = s
            state.leftTime = formatTime(h, m, s, state.isNegative)
        }

        const getClass = computed(() => {
            let className = 'TtnTimer '
            if (state.isNegative) return className + 'TtnTimer--red'
            if (state.hours < 12) return className + 'TtnTimer--red'
            if (state.hours < 24) return className + 'TtnTimer--yellow'
            return className
        })

        onMounted(() => {
            if (!props.delayedTime) return

            const { negative, h, m, s } = parseTime(props.delayedTime)
            state.isNegative = negative
            state.hours = h
            state.minutes = m
            state.seconds = s
            state.leftTime = formatTime(h, m, s, negative)

            setInterval(tick, 1000)
        })

        return { state, getClass }
    },
})
